import axios from 'axios'
import qs from 'qs'
import Vue from 'vue'

let config = {
    timeout: 20000,
    baseURL: 'https://culture.aqitai.com/',
    headers:{
        // 'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
        // 'Authorization': ''
    },
    responseType: "json",
    transformRequest: [data => qs.stringify(data)]
};

export default {
    get (option) {
        let keyVal = {
            apiterminal: 'Aqt_20230517ApiWeb'
        }
        Vue.prototype.$set(option, 'data', keyVal)
        config.headers['Authorization'] = 'Bearer ' + (localStorage.getItem('token'))
        let { url, data = {} } = option
        return new Promise((resolve, reject)=>{
            axios.get(url,{params: data, ...config}).then(res=>{
                let obj = {
                    code: res.data.code,
                    data: res.data.data
                }
                resolve(obj);
            }).catch(error=>{
                console.log(989,error)
                if (error.message === 'Request failed with status code 401') {
                    Vm.$router.push('/login')
                }
                reject({message: '页面溜走了，请稍后重试', error: error});
            });
        });
    },

    post (option) {
        let keyVal = {
            apiterminal: 'Aqt_20230517ApiWeb'
        }
        Vue.prototype.$set(option, 'data', keyVal)
        config.headers['Authorization'] = 'Bearer ' + (localStorage.getItem('token'))
        let { url, data = {} } = option
        return new Promise((resolve, reject) => {
            axios.post(url, data, { ...config }).then(res=>{
                resolve(res.data);
            }).catch(error=>{
                if (error.message === 'Request failed with status code 401') {
                    Vm.$router.push('/login')
                }
                reject({message: '页面溜走了，请稍后重试', error: error});
            });
        })
    },

    put (option) {
        let keyVal = {
            apiterminal: 'Aqt_20230517ApiWeb'
        }
        Vue.prototype.$set(option, 'data', keyVal)
        config.headers['Authorization'] = 'Bearer ' + (localStorage.getItem('token'))
        let {url, data = {}}=option;
        return new Promise((resolve, reject) => {
            axios.put(url, data, { ...config }).then(res=>{
                resolve(res.data);
            }).catch(error=>{
                if (error.message === 'Request failed with status code 401') {
                    Vm.$router.push('/login')
                }
                reject({message: '页面溜走了，请稍后重试', error: error});
            });
        })
    },

    delete (option) {
        let keyVal = {
            apiterminal: 'Aqt_20230517ApiWeb'
        }
        Vue.prototype.$set(option, 'data', keyVal)
        config.headers['Authorization'] = 'Bearer ' + (localStorage.getItem('token'))
        let { url, data = {} } = option
        return new Promise((resolve, reject) => {
            axios.delete(url,{data: data, ...config}).then(res=>{
                resolve(res.data);
            }).catch(error=>{
                if (error.message === 'Request failed with status code 401') {
                    Vm.$router.push('/login')
                }
                reject({message: '页面溜走了，请稍后重试！', error: error});
            });
        })
    }
}
